import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticleService } from 'src/app/services/article.services';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-singleproduct',
  templateUrl: './singleproduct.component.html',
  styleUrls: ['./singleproduct.component.css']
})
export class SingleproductComponent implements OnInit {
  @ViewChild('reviewsTab', { static: false }) reviewsTab!: ElementRef;
@ViewChild('reviewsSection', { static: false }) reviewsSection!: ElementRef;

  articleId: any;
  article: any;
  quantity: number = 1;

  rating: number = 0;  // Valeur de la note
  reviewText: string = '';  // Commentaire du produit
  isLoggedIn: boolean = false;

  selectedTeinte: string = ''; // Libellé de la teinte sélectionnée
  selectedVariant: any; // Va
  scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js',
    'assets/js/drift.min.js',            // ✅ manquant
    'assets/js/model-viewer.min.js',     // ✅ manquant
    'assets/js/zoom.js'                  // ✅ manquant
  ];
 wishlistCount: number = 0;
  cartCount: number = 0;

  constructor(private route: ActivatedRoute,
     private articleservice: ArticleService,
     private scriptLoader: ScriptLoaderService, private authService: AuthServiceService ,    private router: Router,
private wishlist : WishlistService,
     private cdr: ChangeDetectorRef,
     private cartService :CartService) { }

     ngAfterViewInit() {
      if (this.reviewsTab && this.reviewsSection) {
        console.log('reviewsTab et reviewsSection sont prêtes.');
      } else {
        console.warn('reviewsTab ou reviewsSection ne sont pas encore disponibles.');
      }
    }
    openCartManuellement(): void {
      const modalElement = document.getElementById('shoppingCart');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
    cartItems: any[] = [];

    // Exemple d'article à ajouter (à remplacer par ton vrai article)
   /*  addToCart(article: any, quantity: number = 1) {
      console.log('👉 Article reçu dans addToCart:', article);

      const existingItem = this.cartItems.find(item => item.id === article.id);

      if (existingItem) {
        existingItem.quantity += quantity;
        console.log('🔁 Article existant, nouvelle quantité:', existingItem.quantity);
      } else {
        const newItem = {
          ...article,
          quantity: quantity
        };
        this.cartItems.push(newItem);
        console.log('🆕 Article ajouté:', newItem);
      }

      console.log('🛒 Contenu du panier après ajout:', this.cartItems);

      this.openCartManuellement();
    } */
    addToCart(event: Event, product: any, quantity: number): void {
      event.preventDefault();

      if (product.details_variant?.length > 0 && !this.selectedTeinte) {

          return;
      }

      const updatedProduct = { ...product };
      let variant = null;

      if (this.selectedTeinte) {
          const selectedVariant = product.details_variant.find((v: any) => v.libelle === this.selectedTeinte);

          if (selectedVariant) {
              // Gestion spécifique des images en base64
              if (selectedVariant.images && selectedVariant.images.length > 0) {
                  // Convertir le tableau de strings en tableau d'objets {data: string}
                  updatedProduct.images = selectedVariant.images.map((img: string) => ({ data: img }));
              } else {
                  // Fallback aux images originales si pas d'images spécifiques
                  updatedProduct.images = [...product.images];
              }

              updatedProduct.libelle = product.libelle;
              updatedProduct.description = selectedVariant.description || product.description;
              updatedProduct.plus_details = selectedVariant.plus_details || product.plus_details;
              updatedProduct.selectedColor = selectedVariant.libelle;
              variant = selectedVariant.libelle;
          }
      }

      this.cartService.addToCart(updatedProduct, quantity, variant);
      Swal.fire({
        icon: 'success',
        title: 'Produit ajouté',
        text: 'Le produit a été ajouté à votre panier!',
        timer: 2000,
        showConfirmButton: false,
      });
      this.loadCartItems();
    //  this.openCartManuellement();


  }


  loadCartItems(): void {
    this.cartItems = this.cartService.getCartItems();
  }
    getCartTotal(): number {
      const total = this.cartItems.reduce((total, item) => {
        const price = item.promo !== 0 ? item.prix_final : item.prix_ttc;
        const itemTotal = price * item.quantity;
        return total + itemTotal;
      }, 0);
      return total;
    }

    getRemainingForFreeShipping(): number {
      const threshold = 99;
      const currentTotal = this.getCartTotal();
      return Math.max(0, threshold - currentTotal);
    }
    goToCheckout() {
      this.router.navigate(['/checkout']);
    }
    goToCart() {
      this.router.navigate(['/cart']);
    }

    formatText(text: string): string {
      if (!text) return '';
      return text.replace(/\. /g, '.<br>');
  }


     ngOnInit(): void {
      this.loadCartItems();
      this.scriptLoader.loadScripts(this.scripts);
       this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });


      console.log("from");

      this.route.params.subscribe(params => {
        const libelle = params['libelle']; // Récupère le libellé
        const articleId = params['id'];
        console.log(articleId);
        if (articleId) {
          this.fetchArticleDetails(articleId);
        } else {
          console.error('Article ID is null');
        }
      });
      this.articleservice.getArticlesById(this.articleId).subscribe((data) => {
        console.log('Article Data:', data);
        this.article = data;
        this.cdr.detectChanges();
      });


      this.articleservice.getArticlesById(this.articleId).subscribe((data) => {
        this.article = data;

        // Sélectionner la première variante par défaut
        if (this.article.details_variant?.length > 0) {
          this.selectTeinte(this.article.details_variant[0]);
        }
      });
    }
     goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
    selectTeinte(variant: any) {
      this.selectedTeinte = variant.libelle;
      this.quantity = 1;

      // Mettre à jour les propriétés de l'article directement
      this.article.libelle = variant.libelle;
      this.article.description = variant.description;
      this.article.plus_details = variant.plus_details;
      this.article.images[0].data = variant.images;
    }

    // Méthode pour changer la teinte via la liste déroulante
    onTeinteChange() {
      // Trouver le variant correspondant à la teinte sélectionnée
      const variant = this.article.details_variant.find(
        (variant: { libelle: string; }) => variant.libelle === this.selectedTeinte
      );
      this.quantity = 1;

      if (variant) {
        // Mettre à jour les propriétés de l'article directement
        this.article.libelle = variant.libelle;
        this.article.description = variant.description;
        this.article.plus_details = variant.plus_details;
        this.article.images[0].data = variant.images;


      }
    }
    getTeinteColor(libelle: string): string {
      const variant = this.article.details_variant.find(
        (variant: { libelle: string; }) => variant.libelle === libelle
      );
      return variant ? variant.icon_color : 'transparent'; // Retourne la couleur ou transparent si non trouvé
    }

    isStarFilled(starIndex: number): boolean {
      return starIndex <= Math.round(this.article?.note || 0);
    }

    increaseQuantity(article: any): void {
      this.quantity++; // Incrémente directement la valeur
      this.updateTotalPrice(article);
    }

    // Décrémente la quantité (minimum 1)
    decreaseQuantity(article: any): void {
      if (this.quantity > 1) {
        this.quantity--; // Décrémente si > 1
        this.updateTotalPrice(article);
      }
    }

    // Met à jour le prix total
    updateTotalPrice(article: any): void {
      article.totalPrice = this.quantity * article.prix_ttc;
    }



  isPromotionActive(promotion: any): boolean {
    const currentDate = new Date();
    const startDate = new Date(promotion.date_debut);
    const endDate = new Date(promotion.date_fin);
    return currentDate >= startDate && currentDate <= endDate;
  }

  getDiscountedPrice(article: any): number {
    if (article.ligne_promotions && article.ligne_promotions.length > 0) {
      const promotion = article.ligne_promotions[0];
      if (this.isPromotionActive(promotion)) {
        return article.prix_ttc * (1 - promotion.valeur / 100);
      }
    }
    return article.prix_ttc;
  }

fetchArticleDetails(id: any): void {
  this.articleservice.getArticlesById(id).subscribe(
    (response: any) => {
      this.article = response;
      console.log('Article fetched:', this.article);

      // Vérification si la catégorie est présente
      if (this.article.category) {
        this.fetchSimilarProducts(this.article.category.id);
      }
    },
    (error: any) => {
      console.error('Error fetching article:', error);
    }
  );
}

// Méthode pour récupérer les produits similaires
similarProducts: any[] = [];

fetchSimilarProducts(categoryId: any): void {
  this.articleservice.getArticlesByCategory(categoryId).subscribe(
    (response: any) => {
      // Exclure l'article actuel et limiter à 5 produits
      this.similarProducts = response.filter((product: any) => product.id !== this.article.id).slice(0, 5);
      console.log('Similar products fetched:', this.similarProducts);
    },
    (error: any) => {
      console.error('Error fetching similar products:', error);
    }
  );
}



  rateProduct(rating: number): void {
    this.rating = rating;
    console.log(`Note sélectionnée : ${this.rating}`);
  }






  getTotalPrice(article: any): number {
    if (!article) {
      return 0;
    }

    const basePrice =
      article.promo !== 0
        ? (article.prix_final || article.prix || 0)
        : (article.prix_ttc || article.prix || 0);

    const quantity = article.quantity || 1;

    return basePrice * quantity;
  }


  getColor(teinte: string): string {
    switch (teinte) {
      case '01 nude wave':
        return '#D19A8B';
      case '02 coton candy':
        return '#E46D8A';
      case '05 berry much':
        return '#B8325B';
      case '07 cherry boom boom':
        return '#A5072C';
      case '11 funky brown':
        return '#8C3B3B';
      default:
        return '#ccc'; // Couleur par défaut
    }
  }

  goToReviews() {
    setTimeout(() => {
      const reviewsTab = document.querySelector('#reviews-tab') as HTMLElement;
      const reviewsSection = document.querySelector('#reviews') as HTMLElement;

      if (reviewsTab && reviewsSection) {
        // Désactiver les autres onglets
        const tabs = document.querySelectorAll('.nav-link');
        tabs.forEach(tab => tab.classList.remove('active'));

        // Activer l'onglet Avis
        reviewsTab.classList.add('active');

        // Désactiver les autres contenus
        const tabContents = document.querySelectorAll('.tab-pane');
        tabContents.forEach(tab => tab.classList.remove('active', 'show'));

        // Activer le contenu Avis
        reviewsSection.classList.add('active', 'show');

        // Défilement fluide vers la section Avis
        reviewsSection.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          window.scrollBy(0, -210);
        }, 500);
      } else {
        console.error('Les éléments reviews-tab ou reviews ne sont pas trouvés dans le DOM.');
      }
    }, 0);
  }


}
